var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full mt-2"},[_c('a',{class:_vm.isClickDisabled ? 'link-disabled cursor-not-allowed' : 'link-popup',attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.isClickDisabled ? null : _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }